import type { StreamStatus } from '../lib/sse';

/**
 * نصّ شارة «إشارة النظام» في القشرة — **ادعاءٌ يقرؤه المالك على كل شاشة**.
 *
 * كان يُشتق من `navigator.onLine` وحده، وهو يقول إن للجهاز واجهة شبكة لا إن التحديث
 * الحيّ يعمل: بوّابة فندق، أو خادم ساقط، أو جلسة منتهية — كلها تُبقي «مباشرة» معروضة
 * والبيانات مجمّدة. ومنذ صار للتطبيق اتصال بثّ واحد بحالة معروفة
 * (`app/stream-provider.tsx`) صار الادعاء يُقابَل بها.
 *
 * وهو في ملف بلا مكوّن عمدًا: `shell.tsx` يستورد `virtual:pwa-register/react` فلا
 * يُحمَّل في اختبار وحدة — ومنطقٌ يُقرأ منه المالك حكمًا يستحق اختبارًا لا استثناءً.
 */
export function liveLabel(online: boolean, status: StreamStatus): { text: string; warn: boolean } {
  // غير متصل حقيقة أقوى من حالة البثّ: لا معنى لتفصيل سببٍ ثانٍ فوقها.
  if (!online) return { text: 'آخر نسخة محفوظة', warn: true };
  // `connecting` ليست إنذارًا: `EventSource` يعيد المحاولة بنفسه، ووميضُ تحذيرٍ مع كل
  // انقطاع لحظي يُدرِّب المالك على تجاهل الشارة — وهو ما يُفقدها قيمتها حين تصدق.
  if (status === 'stalled') return { text: 'التحديث الحيّ متوقف', warn: true };
  return { text: 'مباشرة', warn: false };
}
